import React, { memo, useContext } from 'react';
import { Image, Layout } from 'antd';
import { Link } from 'react-router-dom';
import BaseMenu from './BaseMenu';
import { MenuItem } from '@/types';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar } from '@/graphql/operations/user';
import BaseLayoutContext, { ILayoutContext } from '@/context/LegacyLayoutContext';
import styles from './SideMenu.module.pcss';

const { Sider } = Layout;

interface Props {
  menuItems: Array<MenuItem>;
  isCollapsed: boolean;
  toggleSideBar: () => void;
}

const SideMenu = memo<Props>((props) => {
  const currentUser = useReactiveVar(currentUserVar);
  const layoutContext = useContext<ILayoutContext>(BaseLayoutContext);

  const renderCustomerLogo = () => {
    if (props.isCollapsed && layoutContext.layoutConfig?.shortLogo) {
      return layoutContext.layoutConfig.shortLogo;
    }
    return layoutContext.layoutConfig.logo;
  };

  return (
    <Sider
      trigger={null}
      breakpoint="lg"
      collapsible
      theme="light"
      collapsed={props.isCollapsed}
      collapsedWidth={layoutContext.siderWidth}
      className={styles.sider}
    >
      <div className={styles.logo}>
        <Link to={currentUser.permissions?.isAdmin ? '/plans' : '/my-pay'}>
          <Image src={renderCustomerLogo()} alt="logo" preview={false} />
        </Link>
      </div>
      <BaseMenu {...props} mode="inline" />
    </Sider>
  );
});

export default SideMenu;
